import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollEffects {

    Funkprotokoll$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL),
        mergeMap((x: ac.GetFunkprotokollAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokoll(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
